<template>
  <div>
    <section-title
      v-if="!isReadOnly"
      content="Información del Proveedor"
      :has-line="true"
    />
    <div v-if="!isReadOnly" class="rounded pt-2 pb-3 px-4">
      <div class="row">
        <div class="col-md-4">
          <label class="data-title mb-n3">SSN Patronal:</label>
          <span class="data-content d-block">
            {{ model.ssn | empty }}
          </span>
        </div>
        <div class="col-md-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <label class="data-title mb-0">Tipo de Proveedor:</label>
            <custom-drop-down
              v-model="model.providerType"
              :clearable="false"
              custom-error-msg="El tipo de proveedor es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="providerTypes"
              placeholder="Seleccione"
              @input="onChangeProviderTypeHandler"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 d-flex align-items-center pt-2">
          <check-box
            v-if="isCompanyProviderType"
            v-model="model.isIncorporatedCompany"
            class="my-2 check-box__extended"
            text="¿Compañía es incorporada?"
          />
          <check-box
            v-if="isIndividualProviderType"
            v-model="model.isServiceAssistant"
            class="my-2 check-box__extended"
            text="¿Es Asistente de Servicio?"
          />
        </div>
        <div v-if="isCompanyProviderType" class="col-md-12 pt-0">
          <validation-provider v-slot="{ errors }" rules="required">
            <label class="data-title mb-0">Nombre del Proveedor:</label>
            <custom-input
              v-model="model.providerName"
              custom-error-msg="El nombre del proveedor es requerido."
              :error="errors[0]"
              type="text"
            />
          </validation-provider>
        </div>
      </div>
      <div v-if="isIndividualProviderType" class="row mt-2">
        <div class="col-md-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <label class="data-title mb-0">Nombre:</label>
            <custom-input
              v-model="model.nameFirst"
              custom-error-msg="El nombre es requerido."
              :error="errors[0]"
              type="text"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <label class="data-title mb-0">Apellido Paterno:</label>
            <custom-input
              v-model="model.nameLastPaternal"
              custom-error-msg="El apellido paterno es requerido."
              :error="errors[0]"
              type="text"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <label class="data-title mb-0">Apellido Materno:</label>
          <custom-input v-model="model.nameLastMaternal" type="text" />
        </div>
      </div>
      <div v-if="model.primaryCompanyName" class="row mt-2">
        <div class="col-md-12">
          <label class="data-title mb-0">
            Proveedor adicional del mismo Seguro Social con la Compañía
            Primaria:
          </label>
          <span class="color-black font-16 font-weight-bold ml-2">
            {{ model.primaryCompanyName }}
          </span>
        </div>
      </div>
    </div>
    <provider-header-info
      v-else
      v-model="model"
      :is-ssn-masked="isSsnMasked"
      @click="onOpenEditHandler"
      @toggle-ssn-mask="onToggleSSNMaskHandler($event)"
    />
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import SectionTitle from 'SectionTitle';
import ProviderHeaderInfo from './ProviderHeaderInfo.vue';
import CustomDropDown from 'custom-drop-down';
import CheckBox from 'CheckBox';
import CustomInput from 'CustomInput';
import providerTypes from '@/utils/constants/providerTypes.js';

import { getSsn as _getSsn } from '@/services/provider/provider.api.js';

export default {
  name: 'ProviderInfo',
  components: {
    ValidationProvider,
    SectionTitle,
    ProviderHeaderInfo,
    CustomDropDown,
    CheckBox,
    CustomInput,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    providerTypes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isIndividualProviderType() {
      return this.model.providerType?.id === providerTypes.Individual;
    },
    isCompanyProviderType() {
      return (
        this.model.providerType?.id === providerTypes.Company ||
        this.model.providerType?.id === providerTypes.DBA
      );
    },
    hasEditPermission() {
      return this.userHasPermissions(
        'menu.rempro.providers.view.editinfoprovider'
      );
    },
    hasUnMaskSSNPermission() {
      return this.userHasPermissions('rempro.providers.display.ssn');
    },
    companyId() {
      return this.$route.params?.companyId
        ? Number.parseInt(this.$route.params?.companyId)
        : null;
    },
  },
  methods: {
    onChangeProviderTypeHandler() {
      this.model = {
        ...this.model,
        providerName: null,
        nameFirst: null,
        nameLastPaternal: null,
        nameLastMaternal: null,
        isIncorporatedCompany: false,
        isServiceAssistant: false,
      };
    },
    onOpenEditHandler() {
      this.$emit('on-edit-provider-info');
    },
    async onToggleSSNMaskHandler() {
      if (!this.hasUnMaskSSNPermission) return;

      const { data: response } = await _getSsn(
        this.companyId,
        !this.isSsnMasked
      );
      if (response) {
        this.model.ssn = response;
        this.isSsnMasked = !this.isSsnMasked;
      }
    },
  },
  data() {
    return {
      isSsnMasked: true,
    };
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.check-box__extended ::v-deep {
  color: map-get($colors, 'gray-6') !important;
}
.btn-action-size {
  width: 35px;
  height: 35px;
}
.icon-container {
  margin-top: 3px;
  margin-right: 12px;
}
.icon-container .far,
.icon-container .fas {
  font-size: 20px;
}
</style>
